import { render, staticRenderFns } from "./Typo.vue?vue&type=template&id=53599ea6&"
import script from "./Typo.vue?vue&type=script&lang=js&"
export * from "./Typo.vue?vue&type=script&lang=js&"
import style0 from "./Typo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports